module.exports = __webpack_public_path__ + "static/media/hard_block.de640c83.PNG";